import { render, staticRenderFns } from "./SocialVisitsHome.vue?vue&type=template&id=e34229f8&"
import script from "./SocialVisitsHome.vue?vue&type=script&lang=js&"
export * from "./SocialVisitsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports